/**
 * section-collection-grid.js
 *
 * Key fix in this version — desktop drag was silently broken:
 *   The .cg-slider__hover-zones div is position:absolute; inset:0; z-index:3.
 *   JS was setting pointer-events:auto on it, making it a full-card overlay
 *   that swallowed every mousedown before the track could see it.
 *   Fix: mousedown now attaches to .cg-product-card__media (the outer wrapper,
 *   above all internal layers) and hover-zones pointer-events are left alone.
 *
 * Other drag fixes:
 *   - mousemove/mouseup added to document INSIDE mousedown, removed in mouseup
 *     (prevents stale listener buildup across cards)
 *   - isDragging and all drag vars declared at TOP of initSlider (before any
 *     closures that reference them)
 *   - click listener uses capture:true so it fires before the <a> navigates
 *   - Guards skip drag-start when clicking wishlist / arrow buttons
 */
/* ── Add to Bag ──────────────────────────────────────── */

//  document.addEventListener('click', function (e) {
//   const btn = e.target.closest('.dc-atb-btn');

//   if (!btn || btn.disabled) return;

//   const variantId = btn.dataset.dcVariantId;
//   if (!variantId) return;

//   if (btn.classList.contains('loading')) return;

//   // btn.classList.add('loading');
//   // btn.disabled = true;

//   const originalHTML = btn.innerHTML;

//   btn.innerHTML = '<span class="dc-loader"></span>';

//   fetch('/cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'X-Requested-With': 'XMLHttpRequest'
//     },
//     body: JSON.stringify({
//       id: Number(variantId),
//       quantity: 1
//     })
//   })
//     .then(function (response) {
//       if (!response.ok) {
//         throw new Error('Failed to add product');
//       }
//       return response.json();
//     })
//     .then(function () {

//       btn.classList.remove('loading');
//       // btn.innerHTML = 'Added';

//       // Update cart count
//       return fetch('/cart.js');
//     })
//     .then(function (response) {
//       return response.json();
//     })
//     .then(function (cart) {

//       // Update header count
//       document.querySelectorAll(
//         '[data-cart-count], .cart-count, .cart-count-bubble, .header__cart-count'
//       ).forEach(function (el) {
//         el.textContent = cart.item_count;
//       });

//       // Try common Shopify drawer elements
//       const drawer =
//         document.querySelector('cart-drawer') ||
//         document.querySelector('cart-notification') ||
//         document.querySelector('#CartDrawer') ||
//         document.querySelector('.cart-drawer');

//       // Refresh cart data for themes
//       document.dispatchEvent(
//         new CustomEvent('cart:refresh', {
//           bubbles: true,
//           detail: { cart: cart }
//         })
//       );

//       document.dispatchEvent(
//         new CustomEvent('cart:open', {
//           bubbles: true
//         })
//       );

//       // Dawn theme
//       document.dispatchEvent(
//         new CustomEvent('dispatch:cart-drawer:open', {
//           bubbles: true
//         })
//       );

//       // jQuery themes
//       if (window.jQuery) {
//         window.jQuery(document).trigger('cart.requestComplete', [cart]);
//         window.jQuery(document.body).trigger('added.ajaxProduct');
//       }

//       // Native drawer open
//       if (drawer && typeof drawer.open === 'function') {
//         drawer.open();
//         return;
//       }

//       // Click cart icon if available
//       const cartToggle = document.querySelector(
//         '[data-cart-toggle], [data-open-cart], .cart-icon-bubble, .header__icon--cart, [aria-controls="cart-drawer"], [aria-controls="CartDrawer"]'
//       );

//       if (cartToggle) {
//         cartToggle.click();

//         // Check if drawer actually opened
//         setTimeout(function () {
//           const openedDrawer =
//             document.querySelector('cart-drawer[open]') ||
//             document.querySelector('#CartDrawer.active') ||
//             document.querySelector('.cart-drawer.is-active') ||
//             document.querySelector('.drawer.active');

//           if (!openedDrawer) {
//             window.location.href = '/cart';
//           }
//         }, 500);

//         return;
//       }

//       // No drawer found → redirect to cart page
//       window.location.href = '/cart';
//     })
//     .catch(function (error) {
//       console.error('Add to Cart Error:', error);

//       btn.classList.remove('loading');
//       btn.disabled = false;
//       btn.innerHTML = originalHTML;
//     });
// });
(function () {
  'use strict';

  /* ── Root guard ─────────────────────────────────────────── */
  const root = document.querySelector('.collection-grid');
  if (!root) return;

  const sectionId = root.dataset.sectionId;

  /* ── Key elements ───────────────────────────────────────── */
  const panel      = document.getElementById(`cg-filter-panel-${sectionId}`);
  const backdrop   = root.querySelector('[data-filter-backdrop]');
  const closeBtn   = panel && panel.querySelector('[data-filter-close]');
  const applyBtn   = panel && panel.querySelector('.cg-filter-panel__apply');
  const clearBtn   = panel && panel.querySelector('[data-clear-filters]');
  const filterForm = panel && panel.querySelector('.cg-filter-form');

  /* ══════════════════════════════════════════════════════════
     SPINNER
  ══════════════════════════════════════════════════════════ */
  const spinner = document.createElement('div');
  spinner.className = 'cg-page-spinner';
  spinner.setAttribute('aria-hidden', 'true');
  spinner.innerHTML = '<div class="cg-page-spinner__ring"></div>';
  document.body.appendChild(spinner);

  function showSpinner () {
    spinner.classList.add('is-active');
    root.classList.add('collection-grid--loading');
  }
  function hideSpinner () {
    spinner.classList.remove('is-active');
    root.classList.remove('collection-grid--loading');
  }

  /* ══════════════════════════════════════════════════════════
     FILTER PANEL — open / close
  ══════════════════════════════════════════════════════════ */
  function openPanel () {
    if (!panel) return;
    const btn = root.querySelector('[data-filter-toggle]');
    panel.setAttribute('aria-hidden', 'false');
    btn      && btn.setAttribute('aria-expanded', 'true');
    backdrop && backdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    closeBtn && closeBtn.focus();
  }

  function closePanel () {
    if (!panel) return;
    const btn = root.querySelector('[data-filter-toggle]');
    panel.setAttribute('aria-hidden', 'true');
    btn      && btn.setAttribute('aria-expanded', 'false');
    backdrop && backdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  /* Delegated — survives toolbar DOM swaps */
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-filter-toggle]')) openPanel();
    if (e.target.closest('[data-filter-close]'))  closePanel();
  });

  backdrop && backdrop.addEventListener('click', closePanel);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel && panel.getAttribute('aria-hidden') === 'false') {
      closePanel();
    }
  });

  /* ══════════════════════════════════════════════════════════
     BUILD FILTER URL
  ══════════════════════════════════════════════════════════ */
  function buildFilterUrl () {
    const url    = new URL(window.location.href);
    const params = new URLSearchParams();

    const sortBy = url.searchParams.get('sort_by');
    if (sortBy) params.set('sort_by', sortBy);

    if (panel) {
      panel.querySelectorAll('[data-filter-input]').forEach((input) => {
        if (input.type === 'checkbox' && input.checked) {
          params.append(input.name, input.value);
        }
        if (input.type === 'number' && input.value !== '') {
          params.set(input.name, input.value);
        }
      });
    }

    url.search = params.toString();
    return url.toString();
  }

  /* ══════════════════════════════════════════════════════════
     APPLY FILTERS
  ══════════════════════════════════════════════════════════ */
  function applyFilters () {
    const url = buildFilterUrl();
    closePanel();
    fetchCollection(url);
  }

  applyBtn && applyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    applyFilters();
  });

  filterForm && filterForm.addEventListener('submit', (e) => {
    e.preventDefault();
    applyFilters();
  });

  /* ══════════════════════════════════════════════════════════
     CLEAR ALL — visual only, no fetch
  ══════════════════════════════════════════════════════════ */
  clearBtn && clearBtn.addEventListener('click', () => {
    if (!panel) return;
    panel.querySelectorAll('[data-filter-input]').forEach((input) => {
      if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
      if (input.type === 'number') input.value = '';
    });
  });

 /* ══════════════════════════════════════════════════════════
   SORT RADIOS — delegated listener on `root`, which never
   gets replaced (only its children do via replaceWith), so
   this survives every AJAX swap without re-cloning nodes and
   losing the "checked" state.
══════════════════════════════════════════════════════════ */
function bindSortRadios () {
  if (root.__sortRadiosBound) return; // idempotent, safe to call again after each fetch
  root.__sortRadiosBound = true;

  root.addEventListener('change', (e) => {
    const radio = e.target.closest('[data-sort-radio]');
    if (!radio) return;

    const details = radio.closest('details');
    if (details) details.removeAttribute('open');

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', radio.value);
    fetchCollection(url.toString());
  });
}

  bindSortRadios();

  /* ══════════════════════════════════════════════════════════
     AJAX FETCH + DOM SWAP
  ══════════════════════════════════════════════════════════ */
  function fetchCollection (url) {
    showSpinner();
    window.history.pushState({}, '', url);

    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc     = new DOMParser().parseFromString(html, 'text/html');
        const newRoot = doc.querySelector(`#section-${sectionId}`);
        if (!newRoot) return;

        const grid    = root.querySelector('.collection-grid__products');
        const newGrid = newRoot.querySelector('.collection-grid__products');
        if (grid && newGrid) grid.replaceWith(newGrid);

        const bar    = root.querySelector('.collection-grid__toolbar');
        const newBar = newRoot.querySelector('.collection-grid__toolbar');
        if (bar && newBar) bar.replaceWith(newBar);

        syncPanelToUrl();
        initAllSliders();
        initWishlist();
        bindSortRadios();

        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(console.error)
      .finally(hideSpinner);
  }

  /* ══════════════════════════════════════════════════════════
     SYNC PANEL CHECKBOXES TO URL
  ══════════════════════════════════════════════════════════ */
  function syncPanelToUrl () {
    if (!panel) return;
    const params = new URLSearchParams(window.location.search);

    panel.querySelectorAll('[data-filter-input]').forEach((input) => {
      if (input.type === 'checkbox') {
        input.checked = params.getAll(input.name).includes(input.value);
      }
      if (input.type === 'number') {
        input.value = params.get(input.name) || '';
      }
    });

    const sortBy = params.get('sort_by') || '';
    panel.querySelectorAll('[data-sort-radio]').forEach((r) => {
      r.checked = r.value === sortBy;
    });
  }

  /* ══════════════════════════════════════════════════════════
     IMAGE SLIDER — per product card
     Desktop: mouse drag on .cg-product-card__media
     Mobile:  touch swipe on .cg-product-card__media
     Both:    prev/next arrow buttons
  ══════════════════════════════════════════════════════════ */
  function initSlider (card) {
    const track  = card.querySelector('[data-slider-track]');
    const media  = card.querySelector('.cg-product-card__media');
    if (!track || !media) return;

    const dots    = card.querySelectorAll('[data-dot]');
    const prevBtn = card.querySelector('[data-slider-prev]');
    const nextBtn = card.querySelector('[data-slider-next]');
    const total   = card.querySelectorAll('[data-slide]').length;

    if (total <= 1) return;

    /* ── State — declared at top so all closures see them ── */
    let current    = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragDeltaX = 0;
    let dragMoved  = false;

    /* ── goTo ── */
    function goTo (index) {
      current = ((index % total) + total) % total;
      track.style.transform = `translateX(-${current * 100}%)`;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    }

    /* ── Arrow buttons ── */
    if (prevBtn) prevBtn.addEventListener('click', (e) => { e.preventDefault(); goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', (e) => { e.preventDefault(); goTo(current + 1); });

    /* ── Colour swatch clicks → jump to variant image ── */
    const variantMapEl = card.querySelector('.cg-variant-map');
    const variantMap   = variantMapEl ? JSON.parse(variantMapEl.textContent) : {};

    card.querySelectorAll('[data-swatch-variant]').forEach((swatch) => {
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const variantId  = swatch.dataset.swatchVariant;
        const targetSrc  = variantMap[variantId];
        if (!targetSrc) return;

        // /* Find which slide index has a matching image src */
        // const slides = track.querySelectorAll('[data-slide]');
        // let targetIndex = -1;

        // slides.forEach((slide, i) => {
        //   const img = slide.querySelector('img');
        //   if (!img) return;
        //   /* Compare the width-param portion to avoid cdn domain mismatches */
        //   const slideBase = img.src.split('?')[0];
        //   const targetBase = targetSrc.split('?')[0];
        //   if (slideBase === targetBase && targetIndex === -1) targetIndex = i;
        // });
        /* Extract just the image filename (before size suffix and extension)
           e.g. "abc123_image-name" from any CDN URL variant */
        function getImageKey (url) {
          const path = url.split('?')[0];
          const file = path.split('/').pop();
          return file.replace(/_\d+x\d*(\.\w+)?$/, '').replace(/\.\w+$/, '');
        }

       const targetKey = getImageKey(targetSrc);
        const slides    = track.querySelectorAll('[data-slide]');
        let targetIndex = -1;

        slides.forEach((slide, i) => {
          const img = slide.querySelector('img');
          if (!img || targetIndex !== -1) return;
          if (getImageKey(img.src) === targetKey) targetIndex = i;
        });

        if (targetIndex !== -1) goTo(targetIndex);

        /* Mark active swatch */
        card.querySelectorAll('[data-swatch-variant]').forEach((s) => s.classList.remove('is-active'));
        swatch.classList.add('is-active');
      });
    });
    /* ── Touch swipe (mobile) ── */
    let touchStartX = 0;

    media.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    media.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    });

    /* ── Mouse drag (desktop) ──
       IMPORTANT: attached to `media` (the outer wrapper), NOT `track`.
       The hover-zones div sits at z-index:3 inside the media and used to
       intercept every mousedown before track could see it.
       Attaching here (above all internal layers) bypasses that problem.
    ── */
    function onMouseMove (e) {
      if (!isDragging) return;
      dragDeltaX = e.clientX - dragStartX;
      if (Math.abs(dragDeltaX) > 4) dragMoved = true;

      /* Live-move: offset the current slide position by drag amount */
      const pct = (dragDeltaX / track.offsetWidth) * 100;
      track.style.transform = `translateX(calc(-${current * 100}% + ${pct}%))`;
    }

    function onMouseUp () {
      if (!isDragging) return;
      isDragging = false;

      /* Remove live listeners — keeps document clean */
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup',   onMouseUp);

      track.classList.remove('is-dragging');
      track.style.transition = ''; /* restore CSS transition for snap */

      if (dragMoved && Math.abs(dragDeltaX) > 60) {
        goTo(dragDeltaX < 0 ? current + 1 : current - 1);
      } else {
        goTo(current); /* snap back */
      }
      dragDeltaX = 0;
    }

    media.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      /* Skip: wishlist button, arrow buttons */
      if (e.target.closest('.cg-product-card__wishlist')) return;
      if (e.target.closest('.cg-slider__arrow'))         return;

      isDragging = true;
      dragMoved  = false;
      dragStartX = e.clientX;
      dragDeltaX = 0;

      track.style.transition = 'none'; /* kill easing during live drag */
      track.classList.add('is-dragging');

      e.preventDefault(); /* stop text/image selection */

      /* Add to document so drag works even when cursor leaves the card */
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup',   onMouseUp);
    });

    /* Capture-phase click listener — fires BEFORE the <a> tag's handler.
       Blocks navigation if the user actually dragged (vs just clicked). */
    media.addEventListener('click', (e) => {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true /* capture */);
  }

  function initAllSliders () {
    root.querySelectorAll('.cg-product-card').forEach(initSlider);
  }

  initAllSliders();

  /* ══════════════════════════════════════════════════════════
     WISHLIST — localStorage toggle
  ══════════════════════════════════════════════════════════ */
  // const LS_KEY = 'cg_wishlist';

  // function getWishlist () {
  //   try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; }
  //   catch { return []; }
  // }

  // function saveWishlist (list) {
  //   try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch {}
  // }

  // function initWishlist () {
  //   const list = getWishlist();

  //   root.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
  //     const id = btn.dataset.productId;

  //     const fresh = btn.cloneNode(true);
  //     btn.parentNode.replaceChild(fresh, btn);
  //     if (list.includes(id)) fresh.classList.add('is-active');

  //     fresh.addEventListener('click', (e) => {
  //       e.preventDefault();
  //       e.stopPropagation();

  //       let wl = getWishlist();
  //       if (wl.includes(id)) {
  //         wl = wl.filter((i) => i !== id);
  //         fresh.classList.remove('is-active');
  //       } else {
  //         wl.push(id);
  //         fresh.classList.add('is-active');
  //       }
  //       saveWishlist(wl);
  //     });
  //   });
  // }

  initWishlist();

  /* ══════════════════════════════════════════════════════════
     CLOSE SORT DETAILS on outside click
  ══════════════════════════════════════════════════════════ */
  document.addEventListener('click', (e) => {
    root.querySelectorAll('.cg-sort-dropdown').forEach((details) => {
      if (!details.contains(e.target)) details.removeAttribute('open');
    });
  });

})();

(() => {
  if (window.__cgQuickAddInitialized) return;
  window.__cgQuickAddInitialized = true;

  const cache = new Map();

  async function getProduct(handle) {
    if (cache.has(handle)) return cache.get(handle);

    const response = await fetch(`/products/${handle}.js`);

    if (!response.ok) {
      throw new Error('Unable to load product');
    }

    const product = await response.json();

    cache.set(handle, product);

    return product;
  }

  function closeAllPanels() {
    document
      .querySelectorAll('[data-dc-variant-panel]')
      .forEach(panel => {
        panel.classList.add('hidden');
        panel.innerHTML = '';

        const card = panel.closest('.cg-product-card__info');

        if (!card) return;

        const btn = card.querySelector('.dc-atb-btn');

        if (btn) {
          btn.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        }

        const price = card.querySelector('.club-product-card__price-row');

        if (price) {
          price.classList.remove('hidden');
        }
      });
  }

  async function addToCart(variantId, trigger) {
    trigger.disabled = true;
    trigger.classList.add('is-loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh')
      );

      const drawer =
        document.querySelector('cart-drawer') ||
        document.querySelector('[data-cart-drawer]');

      if (drawer) {
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else {
          drawer.classList.add('active');
        }
      } else {
        window.location.href = '/cart';
      }

    } catch (error) {
      console.error(error);

      trigger.disabled = false;
      trigger.classList.remove('is-loading');
    }
  }

  function buildVariantButtons(panel, product) {
    panel.innerHTML = '';

    product.variants.forEach(variant => {
      const button = document.createElement('button');

      button.type = 'button';
      button.className = 'dc-variant-btn';
      button.textContent = variant.title;
      button.dataset.variantId = variant.id;

      if (!variant.available) {
        button.disabled = true;
        button.classList.add('is-sold-out');
      }

      panel.appendChild(button);
    });
  }

  document.addEventListener('click', async event => {

    const variantButton = event.target.closest('.dc-variant-btn');

    if (variantButton) {
      event.preventDefault();

      if (variantButton.disabled) return;

      await addToCart(
        variantButton.dataset.variantId,
        variantButton
      );

      return;
    }

    const addButton = event.target.closest('.dc-atb-btn');

    if (!addButton) return;

    event.preventDefault();

    const card = addButton.closest('.cg-product-card__info');

    if (!card) return;

    const panel =
      card.querySelector('[data-dc-variant-panel]');

    const price =
      card.querySelector('.club-product-card__price-row');

    if (!panel) return;

    const alreadyOpen =
      !panel.classList.contains('hidden');

    if (alreadyOpen) {
      closeAllPanels();
      return;
    }

    try {
      addButton.classList.add('is-loading');

      const product = await getProduct(
        addButton.dataset.productHandle
      );

      addButton.classList.remove('is-loading');

      if (product.variants.length === 1) {
        await addToCart(
          product.variants[0].id,
          addButton
        );
        return;
      }

      closeAllPanels();

      buildVariantButtons(panel, product);

      panel.classList.remove('hidden');

      if (price) {
        price.classList.add('hidden');
      }

      addButton.classList.add('is-open');
      addButton.setAttribute('aria-expanded', 'true');

    } catch (error) {
      console.error(error);
      addButton.classList.remove('is-loading');
    }
  });

  document.addEventListener('click', event => {
    if (
      event.target.closest('.cg-product-card__info')
    ) {
      return;
    }

    closeAllPanels();
  });
})();